import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AlertDialog } from '@/components/alert-dialog'
import type { CadastroImobiliariaCorretorEntity } from '@/features/proposta/entities/cadastro-imobiliaria-corretor.entity'

interface TUseAlterarParticipacaoImobiliariaProps {
  handleSelecaoOpcaoNao: (
    field: {
      onChange: (value: string) => void
    },
    value: string,
  ) => void
  deveMostrarDialog: boolean
}

export function useAlterarParticipacaoImobiliaria({
  handleSelecaoOpcaoNao,
  deveMostrarDialog,
}: TUseAlterarParticipacaoImobiliariaProps) {
  const { t } = useTranslation('proposta')
  const { setValue, trigger } = useFormContext()

  const handleRadioValueChange =
    (field: { onChange: (value: string) => void }, entity: CadastroImobiliariaCorretorEntity) => async (v: string) => {
      if (v === 'Sim') {
        field.onChange(v)
        setValue('detalhesDaProposta.imobiliariasCorretores.formaPagamentoComissao', 'PagaPelaPlaenge', {
          shouldValidate: true,
        })
        setValue('detalhesDaProposta.imobiliariasCorretores.participacoes', [entity.novoCadastro], {
          shouldValidate: true,
        })
      } else {
        if (!deveMostrarDialog) {
          field.onChange(v)
          return
        }
        const result = await AlertDialog.show({
          title: t('detalhes_proposta.imobiliaria.dialog.cancelar_preenchimento.titulo'),
          description: t('detalhes_proposta.imobiliaria.dialog.cancelar_preenchimento.descricao'),
          actions: [
            {
              title: t('detalhes_proposta.imobiliaria.dialog.cancelar_preenchimento.voltar'),
              value: 'cancel',
              variant: 'outline',
            },
            {
              title: t('detalhes_proposta.imobiliaria.dialog.cancelar_preenchimento.confirmar'),
              value: 'confirm',
              variant: 'default',
            },
          ],
        })
        if (result.value === 'confirm') {
          handleSelecaoOpcaoNao(field, v)
        }
      }

      trigger('detalhesDaProposta.imobiliariasCorretores.participacoes')
    }

  return handleRadioValueChange
}
